const getImageUrl = (imgObj) => imgObj?.image_webp || imgObj?.image || null;

export const syncDetailGallery = (imageObjs, altText) => {
    const media = document.querySelector('.product-detail-media');
    if (!media) return;

    const urls = (imageObjs || []).map(getImageUrl).filter(Boolean);
    if (!urls.length) return;

    let carousel = media.querySelector('#product-detail-carousel');
    if (!carousel) {
        const placeholder = media.querySelector('.product-gallery-placeholder');
        if (!placeholder) return;
        const slides = urls.map((url, index) => `
            <div class="carousel-item${index === 0 ? ' active' : ''}">
                <img src="${url}" class="d-block mx-auto" alt="${altText || ''}" ${index === 0 ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async">
            </div>
        `).join('');
        placeholder.outerHTML = `
            <div id="product-detail-carousel" class="carousel slide carousel-fade product-detail-carousel" data-bs-ride="false" data-bs-interval="false">
                <div class="carousel-inner carousel-main-wrap" role="listbox">${slides}</div>
            </div>
        `;
        return;
    }

    const imgs = carousel.querySelectorAll('.carousel-item img');
    if (imgs.length === 1 && urls.length === 1) {
        imgs[0].src = urls[0];
        if (altText) imgs[0].alt = altText;
        return;
    }

    const inner = carousel.querySelector('.carousel-inner');
    if (!inner) return;
    inner.innerHTML = urls.map((url, index) => `
        <div class="carousel-item${index === 0 ? ' active' : ''}">
            <img src="${url}" class="d-block mx-auto" alt="${altText || ''}" ${index === 0 ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async">
        </div>
    `).join('');
};
